type Position = {
  top: number;
  right: number;
  bottom: number;
  left: number;
};

const findContainContext = (el: HTMLElement | null): HTMLElement | null => {
  if (!el) {
    return null;
  }
  if (window.getComputedStyle(el).containerType === 'inline-size') {
    return el;
  }
  return findContainContext(el.parentElement);
};

export const getPositionRelativeToContainContext = (
  element: HTMLElement,
  position?: Position,
) => {
  const rect = position ?? element.getBoundingClientRect();
  const containParent = findContainContext(element.parentElement);

  if (!containParent) {
    return rect;
  }

  const parentRect = containParent.getBoundingClientRect();
  return {
    top: rect.top - parentRect.top,
    left: rect.left - parentRect.left,
    bottom: rect.bottom - parentRect.bottom,
    right: rect.right - parentRect.left,
  };
};
